import { render } from "./ProfileMini.vue?vue&type=template&id=594a8d36"
import script from "./ProfileMini.vue?vue&type=script&lang=js"
export * from "./ProfileMini.vue?vue&type=script&lang=js"

import "./ProfileMini.vue?vue&type=style&index=0&id=594a8d36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__